<!-- timepicker.component.html -->
<div
  class="timepicker-wrapper"
  [attr.data-size]="config.size || 'medium'"
  [class.has-value]="hasValue"
>
  <!-- Label -->
  @if (config.label) {
    <label [attr.for]="inputId" class="timepicker-label" [class.required]="config.required">
      {{ config.label }}
      @if (config.required) {
        <sup class="required-indicator">*</sup>
      }
    </label>
  }

  <!-- Timepicker Container -->
  <div class="timepicker-container" [class.has-error]="showErrorState">
    <kendo-timepicker
      [id]="inputId"
      [value]="value"
      [format]="config.format || 'HH:mm'"
      [placeholder]="config.placeholder || 'HH:mm'"
      [min]="minTime"
      [max]="maxTime"
      [steps]="timeSteps"
      [disabled]="config.disabled ?? false"
      [readonly]="config.readonly ?? false"
      [size]="config.size || 'medium'"
      [fillMode]="config.fillMode || 'outline'"
      [cancelButton]="config.cancelButton ?? true"
      [nowButton]="config.nowButton ?? false"
      [tabIndex]="config.tabIndex ?? 0"
      [popupSettings]="popupSettings"
      (valueChange)="handleValueChange($event)"
      (focus)="handleFocus($event)"
      (blur)="handleBlur($event)"
      (open)="handleOpen()"
      (close)="handleClose()"
      class="custom-timepicker"
    >
    </kendo-timepicker>
  </div>

  <!-- Helper Text Area -->
  @if ((config.hint && !showErrorState) || showErrorState) {
    <div class="helper-text">
      @if (config.hint && !showErrorState) {
        <span class="hint-text">{{ config.hint }}</span>
      }
      @if (showErrorState) {
        <span class="error-text">* {{ currentErrorMessage }}</span>
      }
    </div>
  }
</div>
